let programList = [] // 节目下拉框
let screenPositionList = [] // 屏位下拉框
let tvNoList = [] // 电子餐牌终端号下拉框

export default {
  programList,
  screenPositionList,
  tvNoList
}



// WEBPACK FOOTER //
// ./src/store/program/state.js